import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=4061e9f2&scoped=true"
import script from "./Entities.vue?vue&type=script&setup=true&lang=js"
export * from "./Entities.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Entities.vue?vue&type=style&index=0&id=4061e9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061e9f2",
  null
  
)

export default component.exports